import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RoutingService } from '../services/routing.service';
import { UserService } from '../services/shared/user.service';
import { TerraUtils } from '../shared/TerraUtils';

/** Allow access to the page if the user doesn't have a flag saying he must verify email.
 * If he does have this flag, redirect him to the relevant page. */
@Injectable({
  providedIn: 'root'
})
export class VerifyEmailGuard  {
  constructor(
    private userService: UserService,
    private routingService: RoutingService,
    private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userService.accountDetails$
      .pipe(map(clientDetails => {
        // If user must verifiy email - redirect him to the email verify page
        if (clientDetails.mustVerifyEmail) {
          let emailVerifyUrl = TerraUtils.consts.paths.EMAIL_VERIFICATION;
          const returnUrl = location.pathname + location.search;
          if (returnUrl) {
            this.routingService.setReturnUrlInCookie(returnUrl)
          }
          return this.router.parseUrl(emailVerifyUrl);
        }
        // if the user dones't have to verify email - allow him to access the desired page
        else {
          return true;
        }
      }));
  }
}
